import { RadarTeaser } from "@Components/teaser/RadarTeaser";
import { TeaserWrapper } from "@Components/teaser/TeaserWrapper";
import { WeatherReportTeaser } from "@Components/teaser/WeatherReportTeaser";
import { useTranslations } from "@Context/TranslationContext/TranslationContext";
import { useBusinessUnit } from "@Hooks/useBusinessUnit";
import { BusinessUnit } from "@Models/BusinessUnit";
import classNames from "classnames";
import React from "react";

type TeaserConfig = {
  titleKey: string;
  getRedirectUrl: (businessUnit: BusinessUnit) => string;
  showFor: BusinessUnit[];
  component: React.FC;
  testId: string;
  headerTestId: string;
};

const TEASER_CONFIG: TeaserConfig[] = [
  {
    titleKey: "teaser.radar",
    getRedirectUrl: (businessUnit) =>
      businessUnit === "SRF" ? "/meteo/radar" : "/aura/radar",
    showFor: ["SRF", "RTR"],
    component: RadarTeaser,
    testId: "radar-teaser",
    headerTestId: "radar-teaser-header",
  },
  {
    titleKey: "teaser.weatherReport",
    getRedirectUrl: () => "/meteo/wetterbericht",
    showFor: ["SRF"],
    component: WeatherReportTeaser,
    testId: "weather-report-teaser",
    headerTestId: "weather-report-teaser-header",
  },
];

export const TeaserContainer: React.FC<{
  isHome?: boolean;
}> = ({ isHome }) => {
  const businessUnit = useBusinessUnit();
  const { t } = useTranslations();

  const visibleTeasers = TEASER_CONFIG.filter((teaser) =>
    teaser.showFor.includes(businessUnit),
  );

  return (
    <div
      className={classNames(
        "m:grid m:grid-cols-1 m:gap-2 m:px-2 m:pb-4 m:md:grid-cols-2 m:md:gap-6 m:md:px-8 m:xl:px-10",
        {
          "m:mt-8 m:lg:grid-cols-3 m:xl:gap-8": !isHome,
        },
        {
          "m:mt-2 m:lg:flex m:lg:flex-col m:lg:gap-2": isHome,
        },
      )}>
      {visibleTeasers.map((teaser, index) => (
        <TeaserWrapper
          key={`${teaser.titleKey}-${index}`}
          title={t(teaser.titleKey)}
          redirectUrl={teaser.getRedirectUrl(businessUnit)}
          testId={teaser.testId}
          headerTestId={teaser.headerTestId}>
          <teaser.component />
        </TeaserWrapper>
      ))}
    </div>
  );
};
